import { render, staticRenderFns } from "./TextSettingTranslation.vue?vue&type=template&id=ae1efcd2&scoped=true&"
import script from "./TextSettingTranslation.vue?vue&type=script&lang=js&"
export * from "./TextSettingTranslation.vue?vue&type=script&lang=js&"
import style0 from "./TextSettingTranslation.vue?vue&type=style&index=0&id=ae1efcd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1efcd2",
  null
  
)

export default component.exports